import { createStore } from 'vuex'
import instagram from './instagram'

export default createStore({
  modules: {
    instagram,
  }
})
